import { createSelector } from 'reselect';
import shipmentsSelectors from 'state/shipments/selectors';
import { constants as loadConstants } from 'utils/loads';

import keyGenerator from 'utils/keys';

const getState = (state) => state.loads;
const getExternalProps = (_, shipmentKey, loadKey, fieldKey) => ({
  shipmentKey,
  loadKey,
  fieldKey,
});

const getErrors = (state) => state.errors;

const getLoads = createSelector(
  shipmentsSelectors.getShipment,
  (shipment) => shipment.loads || []
);

const getLoadsFilled = createSelector(
  shipmentsSelectors.getShipment,
  getState,
  ({ loads: loadKeys }, loads) =>
    (loadKeys || []).map((loadKey) => ({ ...loads[loadKey] }))
);

const getLoad = createSelector(
  getState,
  getExternalProps,
  (loads, { loadKey }) => loads[loadKey] || {}
);

const getLoadError = createSelector(
  getErrors,
  getExternalProps,
  (errors, { shipmentKey, loadKey, fieldKey }) =>
    errors
      ? errors[keyGenerator.load({ shipmentKey, loadKey, field: fieldKey })]
      : ''
);

const getNumberOfItems = createSelector(
  getLoad,
  (load) => load[loadConstants.FIELDS.NUMBER_OF_ITEMS]
);
const getSelectedLoadButton = createSelector(getLoad, (load) => 
  load[loadConstants.FIELDS.SWITCH_BUTTON]
);
const getLoadType = createSelector(
  getLoad,
  (load) => load[loadConstants.FIELDS.LOAD_TYPE]
);
const getPalletType = createSelector(
  getLoad,
  (load) => load[loadConstants.FIELDS.PALLET_TYPE]
);
const getLoadWeight = createSelector(
  getLoad,
  (load) => load[loadConstants.FIELDS.TOTAL_WEIGHT] || undefined
);
const getLoadHeight = createSelector(
  getLoad,
  (load) => load[loadConstants.FIELDS.ITEM_HEIGHT]
);
const getLoadLenght = createSelector(
  getLoad,
  (load) => load[loadConstants.FIELDS.ITEM_LENGTH]
);
const getLoadWidth = createSelector(
  getLoad,
  (load) => load[loadConstants.FIELDS.ITEM_WIDTH]
);

const getDefaultPalletSize = (_, typePallet) =>
  loadConstants.PALLET_SIZES[typePallet] || {};

const getLoadSize = createSelector(getLoad, (load) => ({
  item_width: load[loadConstants.FIELDS.ITEM_WIDTH],
  item_length: load[loadConstants.FIELDS.ITEM_LENGTH],
}));
const getDefaultNonPalletSize = (_, typeLoad) =>
  loadConstants.NON_PALLET_SIZES[typeLoad] || {};

const getAllHeightInLoads = createSelector(getLoadsFilled, (loadsFilled) =>
  loadsFilled.map((load) => load.item_height)
);

const getMaxHeightInLoads = createSelector(
  getAllHeightInLoads,
  (AllHeightInLoads) => Math.max(...AllHeightInLoads)
);

const getTotalWeightInLoads = createSelector(getLoadsFilled, (loadsFilled) =>
  loadsFilled.reduce((acc, cur) => acc + cur.total_weight, 0)
);

export default {
  getState,
  getLoads,
  getLoadsFilled,
  getLoad,
  getLoadError,
  getNumberOfItems,
  getLoadType,
  getSelectedLoadButton,
  getPalletType,
  getLoadWeight,
  getLoadHeight,
  getLoadLenght,
  getLoadWidth,
  getDefaultPalletSize,
  getDefaultNonPalletSize,
  getLoadSize,
  getAllHeightInLoads,
  getMaxHeightInLoads,
  getTotalWeightInLoads,
  // getNonPalletizedType,
};
